export default __webpack_public_path__ + "static/media/warning--tanks-crossing--g2.7f43e52c.png";